// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { AsyncPipe, NgIf } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, combineLatest, map } from 'rxjs';
import { ApiTube } from 'src/app/api/remote-api/.tube.generated/models/api-tube';
import { Observe } from 'src/app/modules/shared/utils/as-observable';
import { TubeService } from 'src/app/modules/tube/services/tube.service';
import { LocalizedDatePipe } from '../../../shared/pipes/localizedDate.pipe';
import { TimelineComponent } from '../timeline/timeline.component';
@Component({
  selector: 'app-tube-card',
  templateUrl: './tube-card.component.html',
  styleUrls: ['./tube-card.component.scss'],
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    NgIf,
    TimelineComponent,
    AsyncPipe,
    TranslateModule,
    LocalizedDatePipe,
  ],
})
export class TubeCardComponent {
  @Input({ required: true }) tube!: ApiTube;
  @Observe('tube') tube$!: Observable<ApiTube>;

  markers = this.tubeService.markers;

  // current tube markers filtered by this.data.currentTubeStatus
  marker$ = combineLatest([this.tube$, this.markers.lastSuccessfulData$]).pipe(
    map(([tube, markers]) => {
      return markers.find(
        (marker) => marker.generalSeverity === tube.currentTubeStatus
      );
    })
  );

  // fires once all data is there
  markersAndTubesReady$ = combineLatest([
    this.tube$,
    this.markers.lastSuccessfulData$,
  ]).pipe(map(() => true));

  constructor(protected tubeService: TubeService) {}
}
